import React from 'react';
import { uniqueId } from 'lodash';
import SkeletonElement from '../../../../components/skeletons/SkeletonElement';

const SELLER_GROUPS_COUNT = 3;

const ScoreboardModalSkeleton = () => {
  const sellerGroups = [...Array(SELLER_GROUPS_COUNT)].map((sellerGroup, index) => (
    <div key={uniqueId()}>
      {!!index && <hr />}
      <div className="d-flex justify-content-between">
        <SkeletonElement type="label" />
        <SkeletonElement type="label-short" />
      </div>
    </div>
  ));

  return (
    <div>
      {sellerGroups}
    </div>
  );
};

export default ScoreboardModalSkeleton;
